import { POST_JOB_FLOW } from 'Douleutaras/views/job/post-job/types';
import { useLocation, useSearchParams } from 'react-router-dom';

// Extract "flow" from a location state or url
export const useFlowParam = (): POST_JOB_FLOW | undefined => {
  const [ searchParams ] = useSearchParams();
  const location = useLocation();

  const flowParam = searchParams.has('flow') ? searchParams.get('flow') : location.state?.flow;

  if (!flowParam) {
    return POST_JOB_FLOW.LEGACY;
  }

  // Check if the flow parameter is a valid enum value
  return Object.values(POST_JOB_FLOW)
    .includes(flowParam as POST_JOB_FLOW)
      ? (flowParam as POST_JOB_FLOW)
      : undefined;
};
